exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-a420efe8] .dropdown-link>a{display:none}[data-v-a420efe8] .dropdown-link .dropdown{opacity:1;position:relative;top:unset;right:unset;pointer-events:all;padding:0}[data-v-a420efe8] .dropdown-link .dropdown .dropdown-inner{border-radius:0;background-color:unset;box-shadow:none;min-width:0;padding:0}", ""]);

// exports
